import { Order, OrderStatus } from "../../../core/models/entities/Order";
import { deriveDeliveryMode } from "./deliveryMode";

// "Ready for pickup" (flag REACT_APP_PICKUP_READY_STATUS_ENABLED): a PICKUP
// order whose internal status is "Order Shipped" is shown to the customer as
// "Ready for pickup" - the internal status value is untouched (status job,
// feed, storage and tracking all key on "Order Shipped"). Pickup detection is
// deriveDeliveryMode (AFHENT/ALM/PICKUP); a blank shippingService is NOT
// pickup, so old orders keep "Order shipped". Pure - no i18n, no env.
export function isReadyForPickup(order: Order, flagEnabled: boolean): boolean {
  return (
    flagEnabled &&
    order.status === OrderStatus.OrderShipped &&
    deriveDeliveryMode(order) === "pickup"
  );
}
